<template>
  <div class="chartBox">
    <div class="pie">
      <div class="exposureBox">
        <dv-border-box-8>
          <div class="exposure">
            <div class="new_exposure_title">曝光量</div>
            <dv-decoration-3 style="width: 150px; height: 30px" />
            <div class="new_exposure_numBox">
              <div class="new_exposure_allNum">
                {{ count < 100000 ? count : "100000+" }}
              </div>
              <div class="new_exposure_sonNum">
                <div class="new_exposure_seoNum">
                  <p class="seoNum_title">搜索引擎曝光量</p>
                  <p class="seoNum_num">{{ browseSum }}</p>
                </div>
                <div class="new_exposure_videoNum">
                  <p class="seoNum_title">短视频曝光量</p>
                  <p class="seoNum_num">{{ playbackVolume }}</p>
                </div>
              </div>
            </div>
          </div>
        </dv-border-box-8>
      </div>
      <div class="pieChart">
        <div class="pieChart_title">搜索引擎数据</div>
        <div class="pieChart_info">
          <div id="piePageViewsChart" ref="piePageViewsChart"></div>
          <div id="pieVisitChart" ref="pieVisitChart"></div>
          <div id="pieReleasesChart" ref="pieReleasesChart"></div>
		  <div id="piePagesChart" ref="piePagesChart"></div>
          <div class="pieChart_label">
            <div
              v-for="(item, i) in pieReleasesData"
              :key="i"
              class="label_list"
            >
              <div class="label_bg0" :class="['label_bg' + i]"></div>
              <div class="label_list_name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 子站数据 -->

    <div class="sonStation">
      <dv-border-box-10>
        <div class="sonStation_warp">
          <div class="title">搜索引擎子站数据</div>
          <div class="sonStationCharts">
            <div class="list">
              <div class="listCont">
                <happy-scroll color="rgba(176,199,249)" size="3" resize hide-horizontal>
                  <el-table
                    :data="stationList"
                    style="width: 100%"
                    highlight-current-row
                    :cell-style="cellStyle"
                  >
                    <el-table-column label="选择" width="50">
                      <template slot-scope="scope">
                        <el-radio v-model="tableRadio" :label="scope.row.id"
                          >&nbsp;</el-radio
                        >
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="label"
                      label="总站名"
                      show-overflow-tooltip
                    ></el-table-column>
                  </el-table>
                </happy-scroll>
              </div>
            </div>
            <div class="mapBox">
              <div class="big" @click="showMap" v-if="mapData.length > 0">
                <i class="iconfont icon-fangda"></i>
                <span>放大地图</span>
              </div>
              <WorldMap :mainUrl="mainUrl" @getMapData="getMapData" />
            </div>
            <div class="sonStation_right">
              <div id="Charts" ref="Echarts"></div>
            </div>
          </div>
        </div>

        <!-- <div class="stationList">
        <div class="title_Box"></div>
        <div style="height:398px">
          <dv-border-box-11 style="height:100%" title="总站列表">
            <div style="height:99%">
      <happy-scroll color="rgba(176,199,249)" size="8" resize>-->
        <!-- <div class="title">总站列表</div> -->
        <!-- <div class="listCont">
                  <el-table
                    :data="stationList"
                    style="width: 100%"
                    highlight-current-row
                    :cell-style="cellStyle"
                  >
                    <el-table-column label="选择项" width="100">
                      <template slot-scope="scope">
                        <el-radio v-model="tableRadio" :label="scope.row.id">&nbsp;</el-radio>
                      </template>
                    </el-table-column>
                    <el-table-column prop="label" label="label"></el-table-column>
                  </el-table>
                </div>
              </happy-scroll>
            </div>
      </dv-border-box-11>-->
        <!-- </div> -->
        <!-- </div> -->
      </dv-border-box-10>
    </div>

    <!-- 短视频 -->
    <div class="videoBox">
      <div class="videoPlay">
        <div class="titleBox">
          <div class="title">
            <!-- <i class="iconfont icon-duanshipin"></i> -->
            短视频播放量
          </div>
          <!-- <div class="sum">
            累计播放量
            <span style="margin-left: 5px">{{ playSumValue }}</span>
          </div> -->
        </div>
        <div class="sumPlayNum">
          <p class="sumPlayNum_title">累计播放量</p>
          <p class="sumPlayNum_count">{{ playSumValue }}</p>
        </div>
        <div style="height: 400px">
          <happy-scroll color="rgba(176,199,249)" size="8" resize>
            <dv-capsule-chart
              :config="capsuleconfig"
              style="width: 80%; height: 380px"
            />
          </happy-scroll>
        </div>
      </div>
      <div class="video_info">
        <div class="titleBox">
          <div class="title">
            <!-- <i class="iconfont icon-duanshipin"></i> -->
            短视频粉丝量
          </div>
        </div>
        <!-- 粉丝量 -->
        <div class="video_info_pie">
          <div id="videoFans" ref="videoFans"></div>
        </div>
        <div class="fansSumValue">累计粉丝量：{{ fansSumValue }}</div>
      </div>
      <div class="video_info">
        <div class="titleBox">
          <div class="title">短视频发布量</div>
        </div>
        <!-- 量 -->
        <div class="video_info_pie">
          <div id="videoRelease" ref="videoRelease"></div>
        </div>
        <div class="fansSumValue">累计发布量：{{ releaseSumValue }}</div>
        <!-- 地图弹窗 -->
        <el-dialog title="全球数据" :visible.sync="isShow">
          <dv-border-box-8>
            <div id="bigMain" ref="worldMap" v-if="isShow"></div>
          </dv-border-box-8>

          <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="isShow = false">确 定</el-button>
          </span>-->
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
//2.引入echartjs
import * as echarts from "echarts";
import { mapState } from "vuex";
import WorldMap from "./WorldMap.vue";
import { mapZHName } from "../../utils/mapName";
import testCopyVue from "../test copy.vue";

export default {
  name: "chart",
  components: {
    WorldMap,
  },
  created() {
    this.userId = JSON.parse(localStorage.getItem("userInfo")).userId;
    this.getStationList();
    this.getExposure();
  },
  computed: {},
  data() {
    return {
      isShow: false,
      mapData: [],
      cellStyle: {
        background: "#034021",
      },
      mainId: "",
      mainUrl: "",
      count: "",
      playbackVolume: "",
      browseSum: "",
      capsuleconfig: {},
      playSumValue: "",
      fansSumValue: "",
      releaseSumValue: "",
      showFBLabelLine: true,
      showFSLabelLine: true,
      sonStation: [], //子站
      stationList: [], //总站
      tableRadio: "",
      userId: "",
      PageViewsData: [], //访问
      pageVisitData: [], //浏览
      pageVisitData: [], //发布
      pieReleasesData: [],
	  piePagesData: [],
      PageViewsSum:'',
      pageVisitSum:'',
      pieReleasesSum:'',
      interval:''

    };
  },

  mounted() {
    var that = this;

    // window.addEventListener("resize", function(){

    //   setTimeout(() => {
    //     console.log(that);getMapData
    //     // that.getChart();
    //   }, 0);
    // })
  },
  watch: {
    sonStation() {
      setTimeout(() => {
        this.getChart();
      }, 100);
    },
    tableRadio(n) {
      // console.log(n);
      this.mainId = n;
      this.getStationData();
      //获取url
      this.stationList.forEach((item) => {
        if (n == item.id) {
          this.mainUrl = item.mainStation;
         
        }
      });
    },
  },

  beforeDistory() {},
  methods: {
    //处理小屏
    small() {
      if (w <= 1600) {
      }
    },
    showMap() {
      // console.log("点击放大");
      this.isShow = true;
      this.$nextTick(() => {
        this.worldConfigure();
      });
    },
    getMapData(data) {
      this.mapData = data;
      // console.log("给父亲的动态数据", this.mapData);
    },
    worldConfigure() {
      // console.log("给父亲的动态数据1", this.mapData);
      const worldMap = echarts.init(this.$refs.worldMap); // 绑定页面div盒子
      window.onresize = worldMap.resize; //实现地图自适应
      worldMap.setOption({
        tooltip: {
          trigger: "item",
          formatter: function (data) {
            // console.log("data", data);
            if (data.data) {
              name =
                data.data.name +
                "<br>" +
                "浏览量：" +
                data.data.value +
                "<br>访客量：" +
                data.data.value2 +
                "<br>访问量：" +
                data.data.value3;
            } else {
              name = data.name;
            }
            return name;
          },
        },
        itemStyle: {
          color: "#fff",
        },
        visualMap: {
          show: true,
          top: "40%",
          left: "5%",
          // min: 1,
          // max: 100000,
          text: ["High", "Low"],
          textStyle: {
            color: "#fff",
          },
          realtime: false,
          // calculable: true,
          inRange: {
            color: ["#FFBD88", "#FFCA4C", "#fc8452", "#c92a36"],
          },
        },

        series: [
          {
            top: 110,
            nameMap: mapZHName,
            type: "map",
            zoom: 1,
            mapType: "world",
            roam: true,
            label: {
              normal: {
                show: true,
                color: "#fff",
                fontSize: "16px",
                formatter: function (val) {
                  // console.log(val);
                  if (val.data) {
                    return val.data.name + "\n" + "浏览量" + val.data.value;
                  } else {
                    return "";
                  }
                },
              },
              emphasis: {
                show: true,
                color: "#ffffff",
                itemStyle: {
                  color: "#ffffff",
                },
              },
            },
            // 地图区域的多边形 图形样式
            itemStyle: {
              color: "#fff",
              areaColor: "#091E64", // 地图区域的颜色 如果设置了visualMap，areaColor属性将不起作用
              borderWidth: 0.5, // 描边线宽 为 0 时无描边
              borderColor: "#024DBA", // 图形的描边颜色 支持的颜色格式同 color，不支持回调函数
              borderType: "solid", // 描边类型，默认为实线，支持 'solid', 'dashed', 'dotted'
            },
            // 高亮状态下的多边形和标签样式
            emphasis: {
              label: {
                show: true, // 是否显示标签
                color: "#ffffff", // 文字的颜色 如果设置为 'auto'，则为视觉映射得到的颜色，如系列色
              },
              itemStyle: {
                areaColor: "#9199f4 ", // 地图区域的颜色
              },
            },

            data: this.mapData,
          },
        ],
      });
    },
    getExposure() {
      this.$http.getExposureFromUserId(this.userId).then((res) => {
        // console.log("曝光量", res);
        if (res.data.code == 200) {
          let data = res.data.data;
          this.count = data.count;
          this.browseSum = data.browseSum;
          this.count = data.count;
          this.playbackVolume = data.playbackVolume;
        }
      });
    },
    //创建图表
    getChart() {
      this.initPie();
      this.initReleasesChart();
      this.initPageViewsChart();
	  this.initPagesChart();
      this.initVideoFans();
      this.initVideoRelease();
      this.initVideoPlay();
    },
    //获取子站列表
    getStationData() {
      let id = 1;
      this.$http.getSonStation(this.mainId).then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          // console.log(res.data);
          this.sonStation = res.data.data;
          this.initLine(this.sonStation);
        } else {
        }
      });
    },
    //获取总站列表
    getStationList() {
      let userId = JSON.parse(localStorage.getItem("userInfo")).userId;
      this.$http.getStationList(userId).then((res) => {
        if (res.data.code == 200) {
          let data = res.data;
          console.log("123", data.data);
          // let nn1 ={
          //   label:"123"
          // }
          // let nn2 ={
          //   label:"1234"
          // }
          this.stationList = data.data;
          // this.stationList.push(nn1)
          // this.stationList.push(nn2)
          this.tableRadio = this.stationList[0].id;
          this.mainId = this.stationList[0].id;
          this.mainUrl = this.stationList[0].mainStation;
          console.log(this.mainUrl);
          // this.getStationData(this.stationList);
        } else {
          // this.$message.error(data.msg);
        }
      });
    },

    //子站详细图
    initLine(source) {
      // console.log("init");
      // 定义图标对象myChart，初始化echarts实例
      let myChart = echarts.init(this.$refs.Echarts);
      let endValue = 8;
      if (document.documentElement.clientWidth < 1600) {
        endValue = 5;
      }
      // 添加配置项
      var options = {
        color: [
          "#62B3DF",
          "#FDDA80",
          "#F549AB",
          // "#5470c6",
          // "#91cc75",
          // "#fac858",
          // "#ee6666",
          // "#73c0de",
          // "#3ba272",
          // "#fc8452",
          // "#9a60b4",
          // "#ea7ccc",
        ],
        //  "color": ['#3E90F3', '#64AFFA', '#0076C2', '#339CFF'],

        legend: {
          type: "plain", // 图列类型，默认为 'plain'
          bottom: "0", // 图列相对容器的位置 top\bottom\left\right
          textStyle: {
            fontSize: "16px",
            color: "#fff",
          },
          formatter: function (name) {
            // console.log("name", name);
            if (!name) return "";
            if (name == "nb_pageviews") {
              name = "浏览量";
            } else if (name == "nb_visits") {
              name = "访问量";
            } else if (name == "number_of_releases") {
              name = "发布量";
            }
            return name;
          },
        },
        tooltip: {
          show: true,
          formatter: function (data) {
            if (data.seriesName == "nb_pageviews") {
              return (
                "<div style='padding:10px'>" +
                data.name +
                "<br/>" +
                "<span style='display:inline-block;margin-right:10px;width:10px;height:10px;border-radius:50%;background:" +
                data.color +
                "'></span>" +
                "浏览量:" +
                data.data.nb_pageviews +
                "</span>" +
                "</div>"
              );
            } else if (data.seriesName == "nb_visits") {
              return (
                "<div style='padding:10px'>" +
                data.name +
                "<br/>" +
                "<span style='display:inline-block;margin-right:10px;width:10px;height:10px;border-radius:50%;background:" +
                data.color +
                "'></span>" +
                "访问量:" +
                data.data.nb_visits +
                "</span>" +
                "</div>"
              );
            } else if (data.seriesName == "number_of_releases") {
              return (
                "<div style='padding:10px'>" +
                data.name +
                "<br/>" +
                "<span style='display:inline-block;margin-right:10px;width:10px;height:10px;border-radius:50%;background:" +
                data.color +
                "'></span>" +
                "发布量:" +
                data.data.number_of_releases +
                "</span>" +
                "</div>"
              );
            }
          },
        },
        dataset: {
          dimensions: [
            "label",
            "nb_pageviews",
            "nb_visits",
            "number_of_releases",
          ],
          source: this.sonStation,
        },
        //         grid: {
        //     x: 40,  //左
        //     y: 40,  //上
        //     x2: 40, //右
        //     y2: 50  //下
        // },
        xAxis: {
          type: "category",
          axisLabel: {},
          axisLabel: {
            interval: 0,
            rotate: -0,
            textStyle: {
              color: "#fff",
              // fontSize:'16px',
            },
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          // max: 2000,
          // min: "dataMin",
          //轴刻度
          // interval: ,
          // max: "dataMax",
          max: function (val) {
            if (Math.ceil(val.max) < 1500) {
              console.log(Math.ceil(val.max));
              return 1500;
            } else {
              return Math.ceil(val.max);
            }
          },
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            // 网格线
            show: true,
            lineStyle: {
              //分割线
              color: "#268C8C",
              width: 1,
              type: "dashed", //dotted：虚线 solid:实线
            },
          },
        },

        dataZoom: [
          {
            //  // 设置滚动条的隐藏与显示
            show: true,
            // 设置滚动条类型
            type: "slider",
            // 设置背景颜色
            // backgroundColor: "rgb(19, 63, 100)",
            // 设置选中范围的填充颜色
            // fillerColor: "rgb(16, 171, 198)",
            // 设置边框颜色
            // borderColor: "rgb(19, 63, 100)",
            // 是否显示detail，即拖拽时候显示详细数值信息
            showDetail: false,
            // 数据窗口范围的起始数值
            startValue: 0,
            // 数据窗口范围的结束数值（一页显示多少条数据）
            endValue: endValue,
            // empty：当前数据窗口外的数据，被设置为空。
            // 即不会影响其他轴的数据范围
            filterMode: "empty",
            // 设置滚动条宽度，相对于盒子宽度
            width: "100%",
            // 设置滚动条高度
            height: 10,
            // 设置滚动条显示位置
            // left: "center",
            // 是否锁定选择区域（或叫做数据窗口）的大小
            zoomLoxk: true,
            // 控制手柄的尺寸
            handleSize: 0,
            // dataZoom-slider组件离容器下侧的距离
            bottom: 3,
          },
          {
            // 没有下面这块的话，只能拖动滚动条，
            // 鼠标滚轮在区域内不能控制外部滚动条
            type: "inside",
            // 滚轮是否触发缩放
            zoomOnMouseWheel: false,
            // 鼠标滚轮触发滚动
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],

        series: [
          {
            type: "bar",
            barMinHeight: 30,
            barWidth: 20,
            barGap: 0,
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              //上方显示数值
              normal: {
                barBorderRadius: [4, 4, 0, 0], // 柱子的圆角，分别为左上、右上、右下、左下
                label: {
                  show: false, //开启显示
                  position: "inside", //在上方显示
                  textStyle: {
                    //数值样式
                    // color: "white",
                    // fontSize: 12
                  },
                  formatter: function (params) {
                    // console.log("params", params);
                    // if (params.value.nb_pageviews > 1) {
                    //   return params.value.nb_pageviews;
                    // } else {
                    //   return " ";
                    // }
                  },
                },
              },
            },
          },
          {
            type: "bar",
            barMinHeight: 20,
            barWidth: 20,
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              //上方显示数值
              normal: {
                barBorderRadius: [4, 4, 0, 0], // 柱子的圆角，分别为左上、右上、右下、左下
                label: {
                  show: false, //开启显示
                  position: "inside", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                  formatter: function (params) {
                    // console.log("params", params);
                    if (params.value.nb_visits > 1) {
                      return params.value.nb_visits;
                    } else {
                      return " ";
                    }
                  },
                },
              },
            },
          },
          {
            type: "bar",
            barMinHeight: 40,
            barWidth: 20,
            emphasis: {
              focus: "series",
            },
            itemStyle: {
              //上方显示数值
              normal: {
                barBorderRadius: [4, 4, 0, 0], // 柱子的圆角，分别为左上、右上、右下、左下
                label: {
                  show: false, //开启显示
                  position: "inside", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                  formatter: function (params) {
                    // console.log("params", params);
                    if (params.value.number_of_releases > 1) {
                      return params.value.number_of_releases;
                    } else {
                      return " ";
                    }
                  },
                },
              },
            },
          },
        ],
      };

      //动态控制滚滚动条
      if (this.sonStation.length > 10) {
        options.dataZoom[0].show = true;
      } else {
        options.dataZoom[0].show = false;
      }
      // 5.将配置给myChart
      myChart.setOption(options);
    },

    //总站-访问量  getAllStationPublic,getObtainAccess,getRetrieve
    initPageViewsChart() {
      this.$http.getObtainAccess(this.userId).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.PageViewsData = data;
            this.PageViewsSum = res.data.msg;
          //test
          // let obj = {
          //   name: "ourqiyi站",
          //   value: 10,
          // };
          // let obj2 = {
          //   name: "qiyiqifu站",
          //   value: 170,
          // };
          // let obj3 = {
          //   name: "sgf365站",
          //   value: 270,
          // };
          // let obj4 = {
          //   name: "sdsygh站",
          //   value: 70,
          // };
          // this.PageViewsData.push(obj);
          // this.PageViewsData.push(obj2);
          // this.PageViewsData.push(obj3);
          // this.PageViewsData.push(obj4);
          let pieChart = echarts.init(this.$refs.piePageViewsChart);
          // 4.添加配置项
          var option;
          option = {
            color: [
              "#DF4A9E",
              "#FFCA4C",
              "#848DF4",
              "#2461C4",
              "#FFBD88",
              "#6AD40D",
              "#fc8452",
              "#27C6FD",
              "#E85CFF",
            ],
            title: [
              {
                text: "", //\n是换行
                subtext: "",
                textStyle: {
                  fontSize: 35, //标题字体
                },
                left: "50%",
                fontWeight: "bold",
                subtextStyle: {
                  fontSize: 20,
                  color: "#fff", //副标题字体
                },
                bottom: "60%",
                textAlign: "center",
              },
            ],

            tooltip: {
              trigger: "item",
            },
            legend: {
              show: false,
            },
            series: [
              {
                name: "访问量",
                type: "pie",
                radius: ["40%", "70%"],
                avoidLabelOverlap: false,
                label: {
                  show: true,
                  position: "center",
                  formatter: "累计访问量"+"\n\n"+this.PageViewsSum,
                  color: "#fff",
                  fontSize: "15",
                },

                labelLine: {
                  show: false,
                },
                data: this.PageViewsData,
              },
            ],
          };
          // this.optionss =option

          pieChart.setOption(option);
        }
      });
    },
    //总站-曝光  getAllStationPublic,getObtainAccess,getRetrieve

    //总站-浏览量图
    initPie() {
      this.$http.getRetrieve(this.userId).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.pageVisitData = data;
            this.pageVisitSum =  res.data.msg;
          //test
          // let obj = {
          //   name: "ourqiyi站",
          //   value: 10,
          // };
          // let obj2 = {
          //   name: "qiyiqifu站",
          //   value: 70,
          // };
          // let obj3 = {
          //   name: "sgf365站",
          //   value: 70,
          // };
          // let obj4 = {
          //   name: "sdsygh站",
          //   value: 70,
          // };
          // this.pageVisitData.push(obj);
          // this.pageVisitData.push(obj2);
          // this.pageVisitData.push(obj3);
          // this.pageVisitData.push(obj4);
          // this.pageVisitData.push(obj);
          let pieChart = echarts.init(this.$refs.pieVisitChart);
          // 4.添加配置项
          var option;
          option = {
            color: [
              "#DF4A9E",
              "#FFCA4C",
              "#848DF4",
              "#2461C4",
              "#FFBD88",
              "#6AD40D",
              "#fc8452",
              "#27C6FD",
              "#E85CFF",
            ],
            title: [
              {
                text: "", //\n是换行
                subtext: "",
                textStyle: {
                  fontSize: 35, //标题字体
                },
                left: "50%",
                fontWeight: "bold",
                subtextStyle: {
                  fontSize: 18, //副标题字体
                  color: "#fff", //副标题字体
                },
                bottom: "1%",
                textAlign: "center",
              },
            ],

            tooltip: {
              trigger: "item",
            },
            legend: {
              show: false,
            },
            series: [
              {
                name: "浏览量",
                type: "pie",
                radius: ["40%", "70%"],
                avoidLabelOverlap: false,
                label: {
                  show: true,
                  position: "center",
                  formatter: "累计浏览量"+'\n\n'+this.pageVisitSum,
                  color: "#fff",
                   fontSize: '15'
                },
                // emphasis: {
                //   label: {
                //     show: true,
                //     fontSize: 40,
                //     fontWeight: "bold"
                //   }
                // },
                labelLine: {
                  show: false,
                },
                data: this.pageVisitData,
              },
            ],
          };

          pieChart.setOption(option);
        }
      });
    },
    //总站-发布量图
    initReleasesChart() {
      this.$http.getAllStationPublic(this.userId).then((res) => {
        // console.log("总站发布量", res);
        if (res.data.code == 200) {
          let data = res.data.data;
          this.pieReleasesData = data;
          this.pieReleasesSum =  res.data.msg;
          //test
          // let obj = {
          //   name: "ourqiyi站",
          //   value: 1170,
          // };
          // let obj2 = {
          //   name: "qiyiqifu站",
          //   value: 2170,
          // };
          // let obj3 = {
          //   name: "sgf365站",
          //   value: 3470,
          // };
          // let obj4 = {
          //   name: "sdsygh站",
          //   value: 1870,
          // };
          // this.pieReleasesData.push(obj);
          // this.pieReleasesData.push(obj2);
          // this.pieReleasesData.push(obj3);
          // this.pieReleasesData.push(obj4);
          let pieChart = echarts.init(this.$refs.pieReleasesChart);
          var option;
          option = {
            color: [
              "#DF4A9E",
              "#FFCA4C",
              "#848DF4",
              "#2461C4",
              "#FFBD88",
              "#6AD40D",
              "#fc8452",
              "#27C6FD",
              "#E85CFF",
            ],
            // color:[
            //        "#FFFF00",
            //   "#87CEFA",
            //   "#FF0000",
            //   "#008000",
            //   "#FF69B4",
            //   "#DA70D6",
            //   "#FFA500",

            // ],
            tooltip: {
              trigger: "item",
            },
            title: [
              {
                text: "", //\n是换行
                subtext: "",
                textStyle: {
                  fontSize: 35, //标题字体
                },
                left: "30%",
                fontWeight: "bold",
                subtextStyle: {
                  fontSize: 18, //副标题字体
                  color: "#fff", //副标题字体
                },
                bottom: "1%",
                textAlign: "center",
              },
            ],

            legend: {
              show: false,
              top: "80",
              right: "-10",
              orient: "vertical",
              selectedMode: false,
              textStyle: {
                color: "#fff",
              },
              formatter: function (name) {
                // console.log("name", name);
                if (!name) return "";
                if (name.length > 10) {
                  // name = name.slice(0, 6) + "...";
                }
                return name;
              },
              tooltip: {
                show: true,
              },
            },
            series: [
              {
                name: "发布量",
                type: "pie",
                // center: ["30%", "50%"],
                radius: ["40%", "70%"],
                avoidLabelOverlap: false,
                label: {
                  show: true,
                  position: "center",
                  color: "#fff",
                  formatter: "累计发布量"+'\n\n'+this.pieReleasesSum,
                  fontSize: '15'
                },
                //中间文字
                // emphasis: {
                //   label: {
                //     show: true,
                //     fontSize: 40,
                //     fontWeight: "bold"
                //   }
                // },
                labelLine: {
                  show: false,
                },
                data: this.pieReleasesData,
              },
            ],
          };

          pieChart.setOption(option);
        }
      });
    },
	//piePagesChart
	//总站-网页数量图
	initPagesChart() {
	  this.$http.getPublishedPages(this.userId).then((res) => {
	    if (res.data.code == 200) {
	      let data = res.data.data;
	      this.piePagesData = data;
	      this.pieReleasesSum =  res.data.msg;
	      let pieChart = echarts.init(this.$refs.piePagesChart);
	      var option;
	      option = {
	        color: [
	          "#DF4A9E",
	          "#FFCA4C",
	          "#848DF4",
	          "#2461C4",
	          "#FFBD88",
	          "#6AD40D",
	          "#fc8452",
	          "#27C6FD",
	          "#E85CFF",
	        ],
	        // color:[
	        //        "#FFFF00",
	        //   "#87CEFA",
	        //   "#FF0000",
	        //   "#008000",
	        //   "#FF69B4",
	        //   "#DA70D6",
	        //   "#FFA500",
	
	        // ],
	        tooltip: {
	          trigger: "item",
	        },
	        title: [
	          {
	            text: "", //\n是换行
	            subtext: "",
	            textStyle: {
	              fontSize: 35, //标题字体
	            },
	            left: "30%",
	            fontWeight: "bold",
	            subtextStyle: {
	              fontSize: 18, //副标题字体
	              color: "#fff", //副标题字体
	            },
	            bottom: "1%",
	            textAlign: "center",
	          },
	        ],
	
	        legend: {
	          show: false,
	          top: "80",
	          right: "-10",
	          orient: "vertical",
	          selectedMode: false,
	          textStyle: {
	            color: "#fff",
	          },
	          formatter: function (name) {
	            // console.log("name", name);
	            if (!name) return "";
	            if (name.length > 10) {
	              // name = name.slice(0, 6) + "...";
	            }
	            return name;
	          },
	          tooltip: {
	            show: true,
	          },
	        },
	        series: [
	          {
	            name: "网页数量",
	            type: "pie",
	            // center: ["30%", "50%"],
	            radius: ["40%", "70%"],
	            avoidLabelOverlap: false,
	            label: {
	              show: true,
	              position: "center",
	              color: "#fff",
	              formatter: "累计网页数量"+'\n\n'+this.pieReleasesSum,
	              fontSize: '15'
	            },
	            //中间文字
	            // emphasis: {
	            //   label: {
	            //     show: true,
	            //     fontSize: 40,
	            //     fontWeight: "bold"
	            //   }
	            // },
	            labelLine: {
	              show: false,
	            },
	            data: this.piePagesData,
	          },
	        ],
	      };
	
	      pieChart.setOption(option);
	    }
	  });
	},
    //短视频_播放
    // /system/views/videoPlay?userId=1
    initVideoPlay() {
      this.$http.getVideoPlay(this.userId).then((res) => {
        if (res.data.code == 200) {
          this.capsuleconfig.data = res.data.data.data;
          // test
          // this.capsuleconfig.data[1].value = 20;
          // this.capsuleconfig.data[2].value = 120;
          // this.capsuleconfig.data[3].value = 200;
          // this.capsuleconfig.data[4].value = 42;
          // this.capsuleconfig.data[5].value = 672;
          // this.capsuleconfig.data[6].value = 92;
          console.log(this.capsuleconfig.data);
          this.playSumValue = res.data.data.sumValue;

          this.capsuleconfig = {
            radius: "50%",
            activeRadius: "55%",
            data: res.data.data.data,
            dataZoom: [
              {
                min : '20%' | 0,
                // 设置滚动条的隐藏或显示
                show: true,
                // 设置类型
                type: "slider",
                // 设置背景颜色
                backgroundColor: "rgb(19, 63, 100)",
                // 设置选中范围的填充颜色
                fillerColor: "rgb(16, 171, 198)",
                // 设置边框颜色
                borderColor: "rgb(19, 63, 100)",
                // 是否显示detail，即拖拽时候显示详细数值信息
                showDetail: false,
                // 数据窗口范围的起始数值
                startValue: 0,
                // 数据窗口范围的结束数值（一页显示多少条数据）
                endValue: 5,
                // 控制哪个轴，如果是number表示控制一个轴，
                // 如果是Array表示控制多个轴。此处控制第二根轴
                yAxisIndex: [0, 1],
                // empty：当前数据窗口外的数据，被设置为空。
                // 即不会影响其他轴的数据范围
                filterMode: "empty",
                // 滚动条高度
                width: 8,
                // 滚动条显示位置
                height: "80%",
                // 距离右边
                right: 3,
                // 控制手柄的尺寸
                handleSize: 0,
                // 是否锁定选择区域（或叫做数据窗口）的大小
                zoomLoxk: true,
                // 组件离容器上侧的距离
                // 如果top的值为'top', 'middle', 'bottom'，组件会根据相应的位置自动对齐
                top: "middle",
             
              },

              {
                // 没有下面这块的话，只能拖动滚动条，
                // 鼠标滚轮在区域内不能控制外部滚动条
                type: "inside",
                // 滚轮是否触发缩放
                zoomOnMouseWheel: false,
                // 鼠标滚轮触发滚动
                moveOnMouseMove: true,
                moveOnMouseWheel: true,
              },
            ],
            digitalFlopStyle: {
              fontSize: 20,
              fill: "#084495",
            },
            // showOriginValue: false,
            animationFrame: 20,
            showValue: true,
          };
          if(!this.playSumValue){       
            this.$nextTick(()=>{
               let ele=document.querySelectorAll('.capsule-item-column')
               ele.forEach(item=>{
                 item.style.width='100%'
               })
            
            })
          }
        }
      });
    },
    //短视频_粉丝
    initVideoFans() {
      this.$http.getVideoFans(this.userId).then((res) => {
        // console.log("resresresresresres1", res.data.data);
        let rightW = "0";
        let bottomW = "5%";
        let topW = null;
        let leftW = null;
        // let radius = ["40%", "70%"];
        let radius = ["30%", "60%"];
        let orientW = "vertical";
        // console.log(
        //   document.documentElement.clientWidth,
        //   "document.documentElement.clientWidth"
        // );
        if (document.documentElement.clientWidth < 1420) {
          (topW = 0), (rightW = 0);
          rightW = null;
          leftW = 0;
          radius = ["30%", "60%"];
          orientW = "horizontal";
        }

        if (res.data.code == 200) {
          let videoFans = echarts.init(this.$refs.videoFans);
          let data = res.data.data.data;
          this.fansSumValue = res.data.data.sumValue;
          //处理0 数据展示
          if (this.fansSumValue) {
            data.forEach((child, index) => {
              if (child.value == 0) {
                child.value = null;
              }
            });
            this.showFSLabelLine = true;
          } else {
            data.forEach((child, index) => {
              // console.log(child.value);
              if (!child.value) {
                child.value = 0;
              }
            });
            this.showFSLabelLine = false;
          }
          data.forEach((child, index) => {
            if (child.value == 0) {
              child.value = null;
            }
          });

          var option;
          option = {
            color: [
              "#DF4A9E",
              "#FFCA4C",
              "#848DF4",
              "#2461C4",
              "#FFBD88",
              "#6AD40D",
              "#fc8452",
              "#27C6FD",
              "#E85CFF",
            ],
            tooltip: {
              trigger: "item",
            },
            title: [
              {
                text: "", //\n是换行
                // subtext: "短视频粉丝量",
                // subtext: "累计粉丝量" + "\n" + this.fansSumValue,
                x: "center",
                y: "center",
                textStyle: {
                  fontSize: 16, //标题字体
                },
                left: "49%",
                fontWeight: "bold",
                subtextStyle: {
                  color: "#fff",
                  fontSize: 16,
                  //副标题字体
                },
                top: "43%",
                textAlign: "center",
              },
            ],

            legend: {
              show: true,
              bottom: bottomW,
              top: topW,
              left: leftW,
              right: rightW,
              orient: orientW,
              selectedMode: false,
              textStyle: {
                color: "#fff",
              },
              type: "scroll",
              scrollDataIndex: 0,
            },
            series: [
              {
                name: "粉丝量",
                type: "pie",
                radius: radius,
                avoidLabelOverlap: false,
                label: {
                  show: this.showFSLabelLine,
                  color: "#fff",
                  formatter: "{b}\t{c}", // 自定义lable处展示那些数据及其格式
                  // formatter: function(name) {
                  //   console.log(name);
                  //   if (name.data.value) {
                  //     let str = name.data.name + "\t" + name.data.value;
                  //     return str;
                  //   }else{

                  //   return ''
                  //   }
                  // },
                  fontSize: 16, // 字体大小
                },
                labelLine: {
                  show: this.showFSLabelLine,
                  length: 10, // 挨着图例的直线的长度
                  length2: 10, // 挨着文字的直线的长度
                },

                data: data,
              },
            ],
          };
          videoFans.setOption(option);
        }
      });
    },
    //短视频_发布量
    initVideoRelease() {
      this.$http.getVideoRelease(this.userId).then((res) => {
        // console.log("发布数据", res);
        if (res.data.code == 200) {
          let data = res.data.data.data;
          this.releaseSumValue = res.data.data.sumValue;
          if (this.releaseSumValue) {
            data.forEach((child, index) => {
              if (child.value == 0) {
                child.value = null;
              }
            });
            this.showFBLabelLine = true;
          } else {
            data.forEach((child, index) => {
              // console.log(child.value);
              if (!child.value) {
                child.value = 0;
              }
            });

            this.showFBLabelLine = false;
          }

          // console.log("resresresresresres1", res.data.data);
          let rightW = "0";
          let bottomW = "5%";
          let topW = null;
          let leftW = null;
          // let radius = ["40%", "70%"];
          let radius = ["30%", "60%"];
          let orientW = "vertical";
          // console.log(
          //   document.documentElement.clientWidth,
          //   "document.documentElement.clientWidth"
          // );
          if (document.documentElement.clientWidth < 1420) {
            (topW = 0), (rightW = 0);
            rightW = 0;
            leftW = 0;
            radius = ["30%", "60%"];
            orientW = "horizontal";
          }

          let videoRelease = echarts.init(this.$refs.videoRelease);
          var option;
          option = {
            tooltip: {
              trigger: "item",
            },
            color: [
              "#DF4A9E",
              "#FFCA4C",
              "#848DF4",
              "#2461C4",
              "#FFBD88",
              "#6AD40D",
              "#fc8452",
              "#27C6FD",
              "#E85CFF",
            ],
            title: [
              {
                text: "", //\n是换行
                // subtext: "短视频粉丝量",
                // subtext: "累计发布量" + "\n" + this.releaseSumValue,
                x: "center",
                y: "center",
                textStyle: {
                  fontSize: 35,
                  color: "#fff", //标题字体
                },
                left: "49%",
                fontWeight: "bold",
                subtextStyle: {
                  color: "#fff",
                  fontSize: 16,
                  //副标题字体
                },
                top: "43%",
                textAlign: "center",
              },
            ],

            legend: {
              bottom: bottomW,
              top: topW,
              left: leftW,
              right: rightW,
              orient: orientW,
              selectedMode: false,
              textStyle: {
                color: "#fff",
              },
              type: "scroll",
              scrollDataIndex: 0,
            },
            series: [
              {
                name: "发布量",
                type: "pie",
                radius: radius,
                avoidLabelOverlap: false,
                label: {
                  show: this.showFBLabelLine,
                  color: "#fff",
                  formatter: "{b}\t{c}", // 自定义lable处展示那些数据及其格式
                  fontSize: 16, // 字体大小
                },
                labelLine: {
                  show: this.showFBLabelLine,
                  length: 10, // 挨着图例的直线的长度
                  length2: 10, // 挨着文字的直线的长度
                },
                data,
              },
            ],
          };
          videoRelease.setOption(option);
        }
      });
    },
  },
};
</script>

<style scoped lang='scss'>
#Charts {
  width: 100%;
  height: 450px;
  // background: #fff;
}
#pieVisitChart {
  position: relative;
  top: -20px;
  width: 25%;
  height: 250px;
  position: relative;
  left: -6%;
}
#piePageViewsChart {
  position: relative;
  top: -20px;
  width: 25%;
  height: 250px;
  left: -6%;
}
#pieReleasesChart {
  position: relative;
  top: -20px;
  width: 25%;
  height: 250px;
  left: -6%;
}
#piePagesChart {
  position: relative;
  top: -20px;
  width: 25%;
  height: 250px;
  left: -6%;
}

.pie {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
::v-deep .el-dialog__header .el-dialog__headerbtn {
  z-index: 99;
}
.exposureBox {
  box-sizing: border-box;
  width: 31%;
  color: #fff;
  height: 286px;
  background: rgb(4, 27, 143);
  box-shadow: rgb(29, 72, 196) 0px 0px 25px 3px inset;

  border-radius: 16px 16px 16px 16px;
  opacity: 1;
  ::v-deep .dv-border-box-8 use:last-child {
    stroke-width: 5;
    clip-path: inset(0px round 16px);
  }
  ::v-deep .dv-border-box-8 use {
    stroke-width: 3;
    clip-path: inset(0px round 16px);
  }

  .exposure {
    padding: 20px;
  }
  // padding: 20px;
  .new_exposure_title {
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
  }
  .new_exposure_numBox {
    position: relative;
    top: -5%;
    width: 100%;
    margin: 2% auto;
    text-align: center;
    .new_exposure_allNum {
      width: 100%;
      font-size: 36px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #95e1f6;
      margin-bottom: 30px;
    }
    .new_exposure_sonNum {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .new_exposure_videoNum {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 49%;
      background: url("@/assets/img/home/numBg.png") no-repeat;
      background-size: 100% 100%;
      height: 67px;
      .seoNum_num {
        margin-top: 5px;
        font-size: 24px;
        font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
        font-weight: 800;
        color: #95e1f6;
        line-height: 28px;
      }
      .seoNum_title {
        font-size: 14px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #edeae9;
      }
    }
    .new_exposure_seoNum {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 49%;
      background: url("@/assets/img/home/numBg.png") no-repeat;
      background-size: 100% 100%;
      height: 67px;
      .seoNum_num {
        margin-top: 5px;
        font-size: 24px;
        font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
        font-weight: 800;
        color: #95e1f6;
        line-height: 28px;
      }
      .seoNum_title {
        font-size: 14px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #edeae9;
      }
    }
  }
  // box-shadow: rgb(29, 72, 196) 0px 0px 50px 3px inset !important ;
}
// jiude
// .exposure {
//   padding: 30px 50px;
//   padding-right: 0;
//   .exposure_cont {
//     padding-left: 10%;
//     padding-top: 10px;
//     display: flex;
//     align-items: center;
//     letter-spacing: 1.5px;
//     .exposure_info {
//       margin-left: 30px;
//       .exposure_title {
//         font-size: 30px;
//         font-weight: 500;
//         margin-bottom: 8px;
//         // color: #12006a;
//         margin-left: 4px;
//       }
//     }
//     .num {
//       font-size: 60px;
//       font-weight: 500;
//       color: rgb(255, 194, 2);
//     }
//   }
//   .exposure_son {
//     display: flex;
//     width: 100%;
//     margin-top: 30px;
//     // padding-left: 40px;
//     .exposure_son_item {
//       text-align: center;
//       width: 50%;
//       font-size: 20px;
//       color: #f0eded;
//     }
//     .exposure_border {
//       border: 3px solid;
//       border-image: linear-gradient(
//           180deg,
//           rgba(25, 162, 255, 0) 10%,
//           rgba(20, 125, 202, 1) 50%,
//           rgba(25, 162, 255, 0) 90%
//         )
//         2 2 2 2;
//     }

//     .exposure_son_num {
//       // text-align: left;
//       // width: 107px;
//       text-align: center;
//       margin-top: 15px;
//       font-size: 25px;
//     }
//   }
//   .exposure_img {
//     background: rgb(255, 194, 2);
//     width: 80px;
//     height: 80px;
//     text-align: center;
//     line-height: 80px;
//     border-radius: 12px;
//   }
//   i {
//     font-size: 40px;
//     color: #fff;
//   }
// }
.pieChart {
  box-shadow: rgb(29, 72, 196) 0px 0px 25px 3px inset;
  position: relative;
  padding: 20px 0;
  padding-left: 30px;
  width: 67%;
  height: 286px;
  background: rgb(4, 27, 143);
  border-radius: 16px 16px 16px 16px;
  opacity: 1;
  box-sizing: border-box;
  // background: #fff;
  // box-shadow: rgb(29, 72, 196) 0px 0px 70px 3px inset !important ;
  .pieChart_title {
    width: 144px;
    height: 32px;
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
    -webkit-background-clip: text;
    // width: 20%;
    // font-size: 20px;
    // font-weight: 500;
    // letter-spacing: 1.5px;
    // padding: 8px 0;
    // padding-left: 15px;
    // color: #ffffff;
    // /*必须设置border宽度和样式*/
    // border-bottom: 1px solid;
    // /*设置线性渐变*/
    // // border-image: linear-gradient(180deg,  rgba(25, 162, 255, 0) 10%, rgba(20, 125, 202, 1) 50%, rgba(25, 162, 255, 0) 90%) 2 2 2 2;
    // border-image: linear-gradient(
    //     to right,
    //     rgb(142, 201, 243),
    //     rgba(27, 2, 131, 0.5)
    //   )
  }
  .pieChart_info {
    display: flex;
    width: 80%;
    height: 224px;
    margin: 0 auto;
    // padding-left: 10%;
  }
  .pieChart_label {
    height: 100%;
    position: absolute;
    top: 5px;
    right: 7%;
    justify-content: center;
    display: flex;
    flex-direction: column;
    .label_list {
      // height: 100%;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 14px;
      margin-bottom: 5px;
      .label_bg0 {
        width: 27px;
        height: 15px;
        border-radius: 3px;
        background: #df4a9e;
        margin-right: 5px;
      }
      .label_bg1 {
        background: #ffca4c;
      }
      .label_bg2 {
        background: #848df4;
      }
      .label_bg3 {
        background: #2461c4;
      }
      .label_bg4 {
        background: #ffbd88;
      }
      .label_bg5 {
        background: #6ad40d;
      }
      .label_bg6 {
        background: #27c6fd;
      }
      .label_bg {
        background: #e85cff;
      }
      .label_name {
        position: relative;
        top: -2px;
        flex: 1;
        max-width: 154px;
      }
    }
  }
}

.chartBox {
  background: rgb(9, 22, 88);
  padding: 0 40px;
  // background: linear-gradient(to bottom, #12006a, #112cb3);
  // display: flex;
}
.sonStation {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  margin-top: 35px;
  justify-content: space-between;
  // box-shadow: rgb(29, 72, 196) 0px 0px 70px 5px inset !important ;
  height: 528px;
  background: rgb(4, 27, 143);
  border-radius: 16px 16px 16px 16px;
  opacity: 1;

  .sonStation_warp {
    padding: 20px 30px;
    opacity: 1;
  }
  .sonStationCharts {
    display: flex;
    width: 100%;
    padding-top: 20px;
    .mapBox {
      width: 50%;
      height: 100%;
      .big {
        // width: 50px;
        position: absolute;
        z-index: 999;
        color: #fff;
        display: flex;
        align-items: center;
        cursor: pointer;
        i {
          font-size: 24px;
        }
        span {
          font-size: 16px;
        }
      }
    }
    .list {
      width: 166px;
      max-height: 400px;
      background: #4e5aa1;
      border-radius: 12px 12px 12px 12px;
      opacity: 1;
      position: absolute;
      bottom: 20px;
      // width: 10%;
      z-index: 997;
      // background: red;

      // display: flex;
      // padding: 20px 15px;
      // color: #fff;

      .listCont {
        // width: 100%;
        height: 140px;
        padding: 10px 10px 10px;
        // padding-top: 10px;
        .list_title {
          color: #fff;
          text-align: center;
          width: 100%;
          font-size: 16px;
          font-weight: 500px;
          margin-bottom: 10px;
          padding-top: 10px;
        }
        .list_item {
          margin-bottom: 10px;

          // color: #bb48b3;
        }
        ::v-deep .el-table{
          padding-bottom: 20px;
          width: 150px !important;
        }
      }

      /*最外层透明*/
      .listCont ::v-deep .el-table {
        background-color: transparent;
        color: white;
      }
      .listCont ::v-deep .el-table__expanded-cell {
        background-color: transparent;
        color: white;
      }
      /* 表格内背景颜色 */
      .listCont ::v-deep .el-table th,
      .listCont ::v-deep .el-table tr,
      .listCont ::v-deep .el-table td {
        background-color: transparent !important;
        border: 0;
        //表格字体颜色
        color: white;
      }

      .listCont ::v-deep .el-table thead tr {
        // background: rgb(35, 74, 172) !important;
      }
      ::v-deep .el-table--border,
      .el-table--group {
        border: 2px solid red !important;
      }
      ::v-deep .el-table--border::after,
      .el-table--group::after,
      .el-table::before {
        display: none;
      }
      ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
      }

      ::v-deep .el-table__body tr.current-row > td.el-table__cell {
        background-color: skyblue;
      }
      ::v-deep .el-table__body tr.current-row > td {
        // background-color: rgb(79, 30, 140) !important;
        background-color: #b800b3 !important;
      }
      //移入
      ::v-deep .el-table tbody tr:hover > td.el-table__cell {
        background-color: #b800b3 !important;
        // background-color: rgb(
        //   79,
        //   30,
        //   140
        // ) !important; //修改成自己想要的颜色即可
      }
    }
    .sonStation_right {
      flex: 1;
      position: relative;
      top: -30px;
    }
  }
  .title {
    height: 32px;
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
    -webkit-background-clip: text;
    // border-left: 5px solid #12006a;

    /*必须设置border宽度和样式*/
    // border-bottom: 1px solid;
    /*设置线性渐变*/
    // border-image: linear-gradient(180deg,  rgba(25, 162, 255, 0) 10%, rgba(20, 125, 202, 1) 50%, rgba(25, 162, 255, 0) 90%) 2 2 2 2;
    // border-image: linear-gradient(
    //     to right,
    //     rgb(142, 201, 243),
    //     rgba(27, 2, 131, 0.5)
    //   )
    //   1;
    // background: linear-gradient(to bottom , rgb(142, 201, 243), rgba(27, 2,131, 0.5));
  }
}
::v-deep .el-dialog {
  height: 80%;
  width: 80%;
  margin-top: 5%;
  background: rgb(9, 22, 88);
  border-radius: 16px 16px 16px 16px;
  box-shadow: rgb(29, 72, 196) 0px 0px 25px 3px inset;
  color: #fff;
}
::v-deep .el-dialog .dv-border-box-8 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
::v-deep .el-dialog .dv-border-box-8 use {
  stroke-width: 3;
  -webkit-clip-path: inset(0px round 16px);
  clip-path: inset(0px round 16px);
}
::v-deep .el-dialog .dv-border-box-8 use:last-child {
  stroke-width: 5;
  clip-path: inset(0px round 16px);
}
::v-deep .el-dialog__body {
  height: 100%;
}
::v-deep .el-dialog__title {
  color: #fff;
  letter-spacing: 1.2 !important;
  font-size: 24px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
}
#bigMain {
  width: 100%;
  height: 100%;
}

.stationList {
  box-sizing: border-box;
  // padding: 20px 0;
  width: 28%;
  height: 400px;
  padding-right: 20px;

  .title_Box {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    .title {
      text-align: right;
      width: 30%;
      border-image: linear-gradient(
          to left,
          rgb(142, 201, 243),
          rgba(27, 2, 131, 0.5)
        )
        1;
    }
  }
  // .title {

  //   border-left: 5px solid #12006a;
  //   font-size: 18px;
  //   font-weight: 500;
  //   padding: 5px 0;
  //   padding-left: 15px;
  //   color: #fff;
  // }

  ::v-deep .dv-border-box-8 use {
    stroke-width: 2;
  }
  ::v-deep .happy-scroll-content {
    width: 100%;
    height: 400px;
  }
  ::v-deep .happy-scroll-container {
    width: 100% !important;
    height: 100% !important;
  }
}
//视频
.videoBox {
  display: flex;
  margin: 35px 0 0;
  padding-bottom: 50px;
  justify-content: space-between;
  .videoPlay {
    box-shadow: rgb(29, 72, 196) 0px 0px 25px 3px inset;
    // background: linear-gradient(
    //   to bottom,
    //   rgba(19, 13, 124, 0.3),
    //   rgba(19, 18, 132, 0.1)
    // );
    // // background-image: linear-gradient(to right, rgba(23, 1, 12), 400px);
    // box-shadow: rgb(29, 72, 196) 0px 0px 80px 5px inset !important ;
    width: 35%;
    // height: 350px;
    // width: 670px;
    height: 540px;
    background: rgb(4, 27, 143);
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
    padding: 20px 30px;
    box-sizing: border-box;
    .titleBox {
      display: flex;
    }
    // overflow: scroll;
    .title {
      height: 32px;
      font-size: 24px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 28px;
      // border-left: 5px solid #12006a;
      // width: 40%;
      // font-size: 20px;
      // font-weight: 500;
      // letter-spacing: 1.5px;
      // padding: 8px 0;
      // padding-left: 15px;
      // color: #ffffff;
      /*必须设置border宽度和样式*/
      // border-bottom: 1px solid;
      /*设置线性渐变*/
      // border-image: linear-gradient(180deg,  rgba(25, 162, 255, 0) 10%, rgba(20, 125, 202, 1) 50%, rgba(25, 162, 255, 0) 90%) 2 2 2 2;
      // border-image: linear-gradient(
      //     to right,
      //     rgb(142, 201, 243),
      //     rgba(27, 2, 131, 0.5)
      //   )
      //   1;
      // background: linear-gradient(to bottom , rgb(142, 201, 243), rgba(27, 2,131, 0.5));
    }
    .sumPlayNum {
      margin: 12px auto 30px;
      width: 50%;
      height: 69px;
      // background: rgb(121, 137, 229, 0.3);
      border-radius: 0px 0px 0px 0px;
      // opacity: 0.3;
      background: url("@/assets/img/home/numBg.png") no-repeat;
      background-size: 100% 100%;
      // border: 2px solid #797ed0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .sumPlayNum_title {
        opacity: 1;
        // width: 70px;
        height: 21px;
        font-size: 14px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #edeae9;
        line-height: 16px;
        text-align: center;
      }
      .sumPlayNum_count {
        opacity: 1;
        text-align: center;
        // height: 36px;
        font-size: 24px;
        font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
        font-weight: 800;
        color: #95e1f6;
        // line-height: 28px;
      }
    }
    .sum {
      position: relative;
      top: 10px;
      flex: 1;
      color: #fff;
      font-size: 18px;
    }
    ::v-deep .happy-scroll-container,
    ::v-deep .happy-scroll-content {
      width: 100% !important;
      height: 100% !important;
    }

    ::v-deep .dv-border-box-10 {
      box-shadow: rgb(29, 72, 196) 0px 0px 70px 8px inset !important;
    }
  }
  .video_info {
    height: 540px;
    background: rgb(4, 27, 143);
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
    box-sizing: border-box;
    padding: 20px 30px;

    width: 30%;
    // background: #fff;
    // box-shadow: rgb(29, 72, 196) 0px 0px 50px 8px inset !important ;
    box-shadow: rgb(29, 72, 196) 0px 0px 25px 3px inset;

    .title {
      // width: 144px;
      height: 32px;
      font-size: 24px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 28px;
    }
    .video_info_pie {
      display: flex;
      margin-top: 60px;
    }
    .fansSumValue {
      text-align: center;
      color: #fff;
      font-size: 20px;
    }
    #videoFans {
      width: 100%;
      height: 350px;
    }
    #videoRelease {
      width: 100%;
      height: 350px;
    }
    ::v-deep .dv-border-box-10 {
      display: none;
      display: flex !important;
      box-shadow: rgb(29, 72, 196) 0px 0px 70px 8px inset !important;
    }
    ::v-deep .dv-border-box-10 .border-box-content {
      display: flex !important;
    }
    .titleBox {
      display: flex;
      .sum {
        color: #fff;
        font-size: 18px;
        position: relative;
        top: 8px;
      }
    }
  }
}
/*  #胶囊柱图柱状样式  */
// .dv-capsule-chart {
//   position: relative;
//   display: -webkit-box;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-orient: horizontal;
//   -webkit-box-direction: normal;
//   -ms-flex-direction: row;
//   flex-direction: row;
//   -webkit-box-sizing: border-box;
//   box-sizing: border-box;
//   padding: 20px;
//   color: #084495 !important;
//   font-size: 30px !important;
// }
// ::v-deep .capsule-item-column {
//   height: 20px !important;
// }
::v-deep .capsule-item {
  box-shadow: none !important;
}
::v-deep .unit-label {
  opacity: 0 !important;
}
// ::v-deep .dv-capsule-chart .label-column {
//   // font-size: 20px;
//   position: relative;
//   div {
//     // height: 30px;
//     // line-height: 30px;
//     // margin-bottom: 18px;
//     color: #fff;
//   }
// }
// ::v-deep
//   .dv-capsule-chart
//   .capsule-item
//   .capsule-item-column
//   .capsule-item-value {
//   font-size: 16px !important;
//   color: #fff;
// }
//@at-roo
::v-deep .dv-scroll-ranking-board {
  color: #333333;
}
::v-deep .dv-scroll-ranking-board .ranking-column {
  border-bottom: 0 !important;
}
::v-deep .dv-scroll-ranking-board .ranking-column .inside-column {
  height: 15px;
}
</style>
<style scoped>
@media screen and (max-width: 1600px) {
  .pieChart .pieChart_label {
    right: 5px;
  }
}
</style>